<template>
    <div class="ObjectLikeButtonsCompact">
        <ObjectLikeButtonsWrapper :status="status" :id="id">
            <template #dislike="{active, onClick}">
                <div  @click="onClick" :class="['ObjectLikeButtonsCompact__button', {'ObjectLikeButtonsCompact__dislike-fill': active}]">
                    <DislikeIcon/>
                </div>
            </template>
            <template #like="{active, onClick}">
                <div @click="onClick" :class="['ObjectLikeButtonsCompact__button', {'ObjectLikeButtonsCompact__like-fill': active}]">
                    <LikeIcon/>
                </div>
            </template>
        </ObjectLikeButtonsWrapper>
    </div>
</template>

<script>
import ObjectLikeButtonsWrapper from "@/components/Object/ObjectLikeButtonsWrapper";
import DislikeIcon from '@/assets/image/icons/dislike-fill.svg?inline';
import LikeIcon from '@/assets/image/icons/like-fill.svg?inline';

export default {
    name: "ObjectLikeButtonsCompact",
    components: {
        ObjectLikeButtonsWrapper,
        DislikeIcon,
        LikeIcon,
    },
    props: {
        status: Number,
        id: [String, Number]
    }
}
</script>

<style lang="scss">
.ObjectLikeButtonsCompact {

  .ObjectLikeButtonsWrapper {
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 16px;
  }

  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  &__dislike-fill {
    @include svgFill($primary);
  }

  &__like-fill {
    @include svgFill($secondary);
  }

}
</style>